// https://stackoverflow.com/questions/30704547/load-google-maps-markers-via-ajax
// https://ultimatecourses.com/blog/everything-you-wanted-to-know-about-javascript-scope
// La funzione fuori dal (document).ready assegnata ad uno scope pubblico è richiamabile anche da files esterni tramite RwMappe.genera_mappa(tassonomia, termine);
var RwMappe = (function () {

  // imposto infowindow per poter chiudere le infowindow aperte prima di aprirne una nuova
  var openInfoWindow;

  // Genera la mappa in base a tassonomia e termine
  var genera_mappa = function (tassonomia, termine, love) {

    $.ajax({
      url : rw_gmaps_vars.ajax_url,
      type : 'post',
      dataType: 'json',
      data : {
        action : 'rw_render_markers',
        security : rw_gmaps_vars.ajax_nonce,
        tassonomia : tassonomia,
        termine: termine,
        love : love
      },
      beforeSend: function() {
      },
      success : function( response ) {

        $('#rw-filtered-map').each(function () {
            map = new_map($(this), response.markers);
            // console.log(response);
            // console.log(map);

        });

      },
      error: function( jqXHR, textStatus, errorThrown ){
        console.log( 'Errore: ' + textStatus, errorThrown );
      },
      complete: function( jqXHR, textStatus ){
        // console.log('complete');
      }
    });


    /*
     *  new_map
     *
     *  This function will render a Google Map onto the selected jQuery element
     *
     *  @type	function
     *  @date	8/11/2013
     *  @since	4.3.0
     *
     *  @param	$el (jQuery element)
     *  @return	n/a
     */


    function new_map($el, markersObj) {

        // vars
        var args = {
          zoom: 2,
  				minZoom: 2,
  				maxZoom: 16,
          gestureHandling: 'cooperative',
          scrollwheel: false,
          mapTypeControl: false,
          streetViewControl: false,
          zoomControl: true,
          zoomControlOptions: {
            style: google.maps.ZoomControlStyle.SMALL
          },
          center: new google.maps.LatLng(42, 12),
          mapTypeId: google.maps.MapTypeId.ROADMAP,
          styles: [{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]}]
        };


        // create map
        var map = new google.maps.Map($el[0], args);

        // add a markers reference
        map.markers = [];

        $.each(markersObj, function (key) {
          // console.log(markersObj[key]);
          add_marker(markersObj[key], map);
        })

        // center map
        center_map(map);

        // return
        return map;

    }

    /*
     *  add_marker
     *
     *  This function will add a marker to the selected Google Map
     *
     *  @type	function
     *  @date	8/11/2013
     *  @since	4.3.0
     *
     *  @param	$marker (jQuery element)
     *  @param	map (Google Map object)
     *  @return	n/a
     */

    function add_marker(markerObjRes, map) {

        $('.gm-style-iw').parent().css('width', 'auto');

        // var
        var latlng = new google.maps.LatLng(markerObjRes.lat, markerObjRes.lng);

        // create marker
        var icon = markerObjRes.icon;

        //add HTML
        var html = markerObjRes.html;

        var marker = new google.maps.Marker({
            position: latlng,
            map: map,
            icon: {
              anchor: new google.maps.Point(16, 32),
              url: 'data:image/svg+xml;utf-8, \
              <svg width="32" height="42.67" viewBox="0 0 32 42.67" xmlns="http://www.w3.org/2000/svg"><path fill="%23000000" d="M14.66,479.12a8,8,0,1,0,8,8A8,8,0,0,0,14.66,479.12Zm0,13.33A5.33,5.33,0,1,1,20,487.12,5.34,5.34,0,0,1,14.66,492.46Zm0-21.33a16,16,0,0,0-16,16c0,6.45,2.25,8.25,14.36,25.81a2,2,0,0,0,3.29,0c12.11-17.55,14.36-19.35,14.36-25.81A16,16,0,0,0,14.66,471.12Zm0,39.49C3,493.83,1.32,492.5,1.32,487.12a13.33,13.33,0,0,1,22.76-9.43A13.25,13.25,0,0,1,28,487.12C28,492.5,26.27,493.83,14.66,510.62Z" transform="translate(1.34 -471.12)"/></svg>'
            },
            html: html
        });

        // add to array
        map.markers.push(marker);

        // if marker contains HTML, add it to an infoWindow
        if (markerObjRes.html) {
        		// create info window
        		var infowindow = new google.maps.InfoWindow({
        			content: markerObjRes.html
        		});

            google.maps.event.addListener(marker, 'click', function() {
							if (openInfoWindow) openInfoWindow.close();
							infowindow.open(map, marker);
							openInfoWindow = infowindow;
						});

            google.maps.event.addListener(map, "click", function(event) {
              infowindow.close();
            });

            google.maps.event.addListener(infowindow,'domready',function(){
              $('#rw-main-infoWindow').closest('.gm-style-iw').parent().addClass('custom-iw');
              if (typeof RwAjaxLove != 'undefined') {
                RwAjaxLove.start();
              }
            });
        }

    }


    // Funzione per visualizzare il contenuto dei pin su un modale invece che su infobox
    // Scommentare riga 223 in cui si appende il modale al body
    var MarkerModal = (function(){
			var
			method = {},
			$overlay,
			$modal,
			$content,
			$close;

			// Center the modal in the viewport
			method.center = function () {
				var top, left;

				top = Math.max($(window).height() - $modal.outerHeight(), 0) / 2;
				left = Math.max($(window).width() - $modal.outerWidth(), 0) / 2;

				$modal.css({
					top:top + $(window).scrollTop(),
					left:left + $(window).scrollLeft()
				});
			};

			// Open the modal
			method.open = function (settings) {
        // console.log('aperto');
				$content.empty().append(settings.content);

				$modal.css({
					width: settings.width || 'auto',
					height: settings.height || 'auto'
				});

				method.center();
				$(window).bind('resize.modal', method.center);
				$modal.fadeIn(800);
				$overlay.fadeIn(800);
			};

			// Close the modal
			method.close = function () {
				$modal.fadeOut(800);
				$overlay.fadeOut(800, function(){
					$content.empty();
					$(window).unbind('resize.modal');
				});
			};

			// Generate the HTML and add it to the document
			$overlay = $('<div id="mm-overlay"></div>');
			$modal = $('<div id="mm-modal"></div>');
			$content = $('<div id="mm-content"></div>');
			$close = $('<a id="mm-close" href="#">close</a>');

			$modal.hide();
			$overlay.hide();
			$modal.append($content, $close);

			// $(document).ready(function(){
			// 	$('body').append($overlay, $modal);
			// });

			$close.click(function(e){
				e.preventDefault();
				method.close();
			});

			return method;
		}());


    /*
     *  center_map
     *
     *  This function will center the map, showing all markers attached to this map
     *
     *  @type	function
     *  @date	8/11/2013
     *  @since	4.3.0
     *
     *  @param	map (Google Map object)
     *  @return	n/a
     */

    function center_map(map) {
      // ToDo: aggiunta dinamica dei markers senza ricreare la mappa
      // https://stackoverflow.com/questions/3251774/google-maps-api-v3-fitbounds-zooms-out-but-never-in

        // vars
        var bounds = new google.maps.LatLngBounds();

        // loop through all markers and create bounds
        $.each(map.markers, function (i, marker) {
            var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
            bounds.extend(latlng);
        });

        // only 1 marker?
        if (map.markers.length == 1) {
            // set center of map
            map.setCenter(bounds.getCenter());
            map.setZoom(16);
        } else {
            // fit to bounds
            map.fitBounds(bounds);
            map.panToBounds(bounds);
        }

    }

  };



  var menu = function () {

    // Quando clicco su qualsiasi tab display (griglia, mappa, lista)
    $('.nav-display li.nav-item a').on('shown.bs.tab', function (e) {
      // Se è la tab mappa passo alla mappa i parametri dei filtri già attivi quando clicco sulla visione mappa
      // e aggiungo le classi attive
      if (e.target.hash == '#mappa') {
          var tassonomia = $('.term-tiles-list span.active').data('tassonomia');
          var termine = $('.term-tiles-list span.active').data('termine');
          var love = $('#start-love').hasClass('love-active') ? 'love-acceso' : 'love-spento';

          //INIZIO GESTIONE ECCEZIONE TAX INTERVISTE
          // se (quando clicco sulla vista mappa) era selezionata precedentemente un termine di tax interviste (che non vengono mai caricate in mappa)
          // clicca sulla tab temi per attivarla e carica tutte le gallery
          // tolgo la classe active dal termine di intervista selezionato
          // altrimenti se clicco griglia -> interviste -> termine e poi mappa, quando torno su griglia mi filtra il termine intervista attivo anche se il tab attivo è temi
          // quindi genero la mappa con tutte le tiles
          if(tassonomia == 'interviste'){
            $('#interviste span.active').removeClass('active');
            $('#temi-tab').click();
            genera_mappa(tassonomia, '', love);
          }
          //FINE GESTIONE ECCEZIONE TAX INTERVISTE

          // Comportamento standard
          else {
            genera_mappa(tassonomia, termine, love);
          }

          $(this).addClass('attivo');
          $('.rw-map-menu').addClass('map-active');
      } else {
        $('.rw-map-menu').removeClass('map-active');
      }
    });


    // Passo alla mappa i parametri dei filtri che seleziono durante la visione mappa
    $('.rw-map-menu span').click(function(){
      // if($('.rw-map-menu').hasClass('map-active')){

      console.log('click su span');

        $('.rw-map-menu span').removeClass('active');
        $(this).addClass('active');

        var tassonomia = $(this).data('tassonomia');
        var termine = $(this).data('termine');
        var love = 'love-spento';
        genera_mappa(tassonomia, termine, love);

        if($(this).attr('ismainarea') == 'true'){
          var zonaAttiva = $(this).data('termine');

          // gestione submenu
          $('#zone-menu').addClass('submenu-attivo');
          $('#zone-menu span[data-parent="'+ zonaAttiva +'"]').toggleClass('zona-attiva');
          $('#zone-menu span:not([data-parent="'+ zonaAttiva +'"])').removeClass('zona-attiva');

          // gestione lista zone
          $('.elenco-zone .area-principale[data-arealist="'+ zonaAttiva +'"]').removeClass('zona-disattiva');
          $('.elenco-zone .area-principale:not([data-arealist="'+ zonaAttiva +'"])').addClass('zona-disattiva');

          console.log(zonaAttiva);
          console.log($('.elenco-zone .area-principale:not([data-arealist="'+ zonaAttiva +'"])'));
        }

        if($(this).is('#trm-tutti')){
          // gestione submenu
          $('#zone-menu').removeClass('submenu-attivo');
          $('#zone-menu span').removeClass('zona-attiva');

          // gestione lista zone
          $('.elenco-zone .area-principale').removeClass('zona-disattiva');
        }

      // }
    });


    var tassonomia = 'zona';
    var termine = 'tutti';
    var love = 'love-spento';

    genera_mappa(tassonomia, termine, love);

  };


  var start = function () {
    menu();
  };


  return {
    start : start
  }


})();
